import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Select } from '@ngxs/store'
import { map, Observable } from 'rxjs'
import { Contact } from '@app/models/contact'
import { QuoteSessionState } from '@app/shared/store/quote-session/quote-session.state'
import { Quote } from '@app/models/quote.model'
import { MaterialModule } from '@app/shared/material.module'
import { OverlayModule } from '@angular/cdk/overlay'

@Component({
	selector: 'app-quote-drawer-heading',
	standalone: true,
	imports: [CommonModule, MaterialModule, OverlayModule],
	templateUrl: './quote-drawer-heading.component.html',
	styleUrls: ['./quote-drawer-heading.component.scss'],
})
export class QuoteDrawerHeadingComponent implements OnInit {
	@Select(QuoteSessionState.contactState)
	public contact$!: Observable<Contact>
	@Select(QuoteSessionState.quoteState)
	public quote$!: Observable<Quote>
	public leadDisplay?: string
	public isZoomiesLead?: boolean
	public contactFullName$: Observable<string>

	constructor() {
		this.contactFullName$ = this.contact$.pipe(
			map((c) => {
				return `${c?.firstName ?? 'Pet'} ${c?.lastName ?? 'Parent'}`
			})
		)

		this.contact$.pipe().subscribe((contact) => {
			this.leadDisplay = contact?.lead
			this.isZoomiesLead = this.leadDisplay?.toLowerCase().includes('zoomies')
		})
	}

	ngOnInit(): void {}
}
